import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=34322234&scoped=true&"
import script from "./TaskProgress.vue?vue&type=script&lang=js&"
export * from "./TaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./TaskProgress.vue?vue&type=style&index=0&id=34322234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34322234",
  null
  
)

export default component.exports